import { Injectable }    from '@angular/core';
import { User }          from '../models/user';
import { Http, Headers } from '@angular/http';
import {AngularFireAuth} from 'angularfire2/auth';
import { Observable }      from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';

@Injectable()
export class UserService {

  private usersUrl = 'https://us-central1-softmart-beef5.cloudfunctions.net/app/users';
  private headers = new Headers({ 'Content-Type': 'application/json' });
  private user: any;

  constructor(private http: Http, private af: AngularFireAuth) {
    this.af.authState.subscribe(user => this.user = user);
  }

  toUser(user) {
    return new User(
      user.id,
      user.name,
      user.email,
      user.url,
      Object.keys(user.roles),
      new Date(user.date),
      user.disabled
    );
  }

  getUsers(): Observable<User[]> {
    return this.af.authState.flatMap(user => !user ?
      Observable.of([]) :
      Observable.fromPromise(<Promise<any>>user.getIdToken()).flatMap(idToken => {
        return this
          .http
          .get(this.usersUrl, { headers: new Headers({'Authorization': `Bearer ${idToken}`}) })
          .map(response => response.json().map(user => this.toUser(user)))
      })
    );
  }

  getUser(id: string): Observable<User> {
    return this.af.authState.flatMap(user => !user ?
      Observable.of(null) :
      Observable.fromPromise(<Promise<any>>user.getIdToken()).flatMap(idToken => {
        return this
            .http
            .get(`${this.usersUrl}/${id}`, { headers: new Headers({'Authorization': `Bearer ${idToken}`}) })
            .map(response => this.toUser(response.json()))
      })
    );
  }

  create(u: User, password): Observable<User> {
    return this.af.authState.flatMap(user => !user ?
      Observable.of(null) :
      Observable.fromPromise(<Promise<any>>user.getIdToken()).flatMap(idToken => {
        return this.http.post(
          this.usersUrl,
          JSON.stringify({
            name: u.name,
            email: u.email,
            roles: this.rolesMap(u.roles),
            password: password,
            url: "https://firebasestorage.googleapis.com/v0/b/softmart-beef5.appspot.com/o/default.png?alt=media&token=ba51db72-b40c-4cca-befe-d010e4c836e6",
            disabled: u.disabled
          }),
          {
            headers: new Headers({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${idToken}`
            })
          }
        ).map(response => this.toUser(response.json()));
      })
    );
  }

  update(u: User):Observable<User> {
    return this.af.authState.flatMap(user => !user ?
      Observable.of(null) :
      Observable.fromPromise(<Promise<any>>user.getIdToken()).flatMap(idToken => {
        return this.http.put(
          `${this.usersUrl}/${u.id}`,
          JSON.stringify({
            name: u.name,
            email: u.email,
            url: u.url,
            roles: this.rolesMap(u.roles),
            disabled: u.disabled
          }),
          {
            headers: new Headers({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${idToken}`
            })
          }
        ).map(response => this.toUser(response.json()));
      })
    );
  }

  rolesMap(roles: string[]) {
    let map: any = {};
    for(let role of roles)
      map[role] = true;
    return map;
  }

  delete(u: User)  {
    return this.af.authState.flatMap(user => !user ?
      Observable.of(null) :
      Observable.fromPromise(<Promise<any>>user.getIdToken()).flatMap(idToken => {
        return this.http.delete(
          `${this.usersUrl}/${u.id}`,
          {
            headers: new Headers({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${idToken}`
            })
          }
        )
      })
    );
  }

  habilitated(u: User)  {
      return this.af.authState.flatMap(user => !user ?
        Observable.of(null) :
        Observable.fromPromise(<Promise<any>>user.getIdToken()).flatMap(idToken => {
          return this.http.patch(
            `${this.usersUrl}/${u.id}`,
            {},
            {
              headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${idToken}`
              })
            }
          )
        })
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/users/services/user.service.ts